import { render, staticRenderFns } from "./MentorStepTwo.vue?vue&type=template&id=0ac3a708"
import script from "./MentorStepTwo.vue?vue&type=script&lang=js"
export * from "./MentorStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports